import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FeedService } from '../../service/feed.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldMappingDialogComponent } from './field-mapping-dialog/field-mapping-dialog.component';
import { MatDialog } from '@angular/material/dialog';



declare var bootstrap: any;

@Component({
  selector: 'app-feed-mapping',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MatTooltipModule, RouterLink],
  templateUrl: './feed-field-mappings.component.html',
  styleUrls: ['./feed-field-mappings.component.css']
})
export class FeedMappingComponent {

  destination = '';
  systemFields: any[] = [];
  form: FormGroup;

  sourceFields: any[] = [];
  productFields: any[] = [];
  computedFields: any[] = [];
  saving = false;



  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private feedService: FeedService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.form = this.fb.group({
      mappings: this.fb.array([])
    });
  }

  get mappingsArray(): FormArray {
    return this.form.get('mappings') as FormArray;
  }

  async ngOnInit() {
    this.destination = this.route.snapshot.paramMap.get('destination') || '';

    await Promise.all([
      this.loadSourceFields(),
      this.loadMappings()
    ]);
  }

  async loadMappings() {
    const result: any = await this.feedService.getTenantFieldMappings(this.destination);

    this.systemFields = result.mappings || [];

    this.mappingsArray.clear();
    this.systemFields.forEach(field => {
      this.mappingsArray.push(
        this.fb.group({
          field_name: [field.field_name],
          required: [field.required === true],
          mapped_field: [field.mapped_field || ''],
          default_value: [field.default_value || ''],
          transformation: [field.transformation || '']
        })
      );
    });
  }

  async saveMappings() {




    const payload = {
      destination_code: this.destination,
      mappings: this.mappingsArray.value
    };

    this.openConnectDialog(payload)


  }

  async loadSourceFields() {
    const fields = await this.feedService.getSourceFields();
    this.sourceFields = fields || [];

    this.productFields = this.sourceFields.filter(
      f => f.source === 'product'
    );

    this.computedFields = this.sourceFields.filter(
      f => f.source === 'computed'
    );
  }

  ngAfterViewInit() {
    this.initTooltips();
  }

  initTooltips() {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );

    tooltipTriggerList.forEach(el => {
      new bootstrap.Tooltip(el);
    });
  }


  openConnectDialog(payload: any) {
    const dialogRef = this.dialog.open(FieldMappingDialogComponent, {
      width: '450px',

      data: {
        destination_code: this.destination,
        mappings: this.mappingsArray.value
      }
    });

    dialogRef.afterClosed().subscribe(async confirm => {
      if (confirm) {
        if (this.saving) return;

        this.saving = true;

        alert(`Saved mappings for ${this.destination}!`);

        await this.feedService.updateTenantMappings(payload);

        this.saving = false;
        this.router.navigate(['/admin/manage-feeds']);
      }
    });

  }

}
